import React, { useCallback, useMemo } from 'react';
import type { AutocompleteProps, SxProps } from '@mui/material';
import type { OptionSchema } from 'c-components';
import { Autocomplete } from 'c-components';
import { useCommonTranslation } from 'c-translation';

type Props = {
    allFields: string[];
    selectedFieldValues: string[];
    setSelectedFieldValues: (fields: string[]) => void;
    sx?: SxProps;
};

const FieldFilter: React.FC<Props> = ({
    allFields,
    selectedFieldValues,
    setSelectedFieldValues,
    sx = {},
}) => {
    const actualOptions = useMemo<OptionSchema[]>(
        () => allFields.map(f => ({ label: f, value: f })),
        [allFields],
    );
    const selectedPlaceholder = useCommonTranslation(
        'Modules.Main.Campaigns.Overview.Reports.selectedTotalPlaceholder',
        { selected: selectedFieldValues.length, total: allFields.length },
    );
    const renderTags: AutocompleteProps<any, any, any, any>['renderTags'] = useCallback(
        () => <>{selectedPlaceholder}</>,
        [selectedPlaceholder],
    );

    return (
        <Autocomplete
            disableCloseOnSelect
            multiple
            options={actualOptions}
            onChange={setSelectedFieldValues}
            value={selectedFieldValues}
            textFieldProps={{ placeholder: '', variant: 'outlined' }}
            renderTags={renderTags}
            sx={sx}
        />
    );
};

export default FieldFilter;
